import AgreementRepository from '../../../repositories/AgreementRepository';
import DistillateFormValidation from './DistillateFormValidation';
import DistillateReview from './DistillateReview';
import RecieverForm from '../shared/RecieverForm';

/**
 * Distillate Agreement form
 */
export default class DistillateForm {
    /**
     * Init
     */
    constructor() {
        // Prevents class being used outside of project scope to avoid errors
        if (document.getElementsByClassName('distillate-agreement').length < 1) {
            return;
        }

        new DistillateReview();
        new RecieverForm('distillate');

        this.submitButton = document.querySelector('#submitDistillateData');

        // Form Validation
        this.validation = new DistillateFormValidation();

        // Repository
        this.repository = new AgreementRepository('distillate');

        // Internal use - Reciever customer.
        // Fetch Reciever data & populate customer drop down
        this.recievers();

        // EventListerners
        this.initEventListerners();
    }

    /**
     * Init EventListnerners in form
     * @returns void
     */
    initEventListerners() {
        // Save data to Api and trigger signing
        this.submitButton.addEventListener('click', this.submitDistillateData);
    }

    /**
     * Submit explsovive precursors
     * @return void
     */
    submitDistillateData = () => {
        this.repository.commonPostAgreementDataAsync(
            '/api/e-signing/agreements/distillate',
            'distillate'
        );
    };

    /**
     * Internal site - Logic for Reciever form
     * @returns void
     */
    recievers() {
        if (document.querySelector('#isInternal').value === 'true') {
            this.repository.fetchRecieverDataAsync('/api/e-signing/get-receivers-for-digital-signing');
        }
    }
}
